import React from "react";

const ProductoRelacionado = props => (
  <div className="col-4">
    <span className="image fit">
      <img
        src={props.articulo.img}
        alt={props.articulo.descripcion}
        title={props.articulo.descripcion}
        style={{ borderRadius: 10 }}
      />
    </span>
    <div style={{ textAlign: "center", marginTop: -30 }}>Art. {props.articulo.codigo}</div>
  </div>
);

export default ProductoRelacionado;
